import { gql } from '@apollo/client';

const REMOVE_LICENSE = gql`
  mutation DeleteUserLicense($externalUserId: Int!) {
    deleteUserLicense(externalUserId: $externalUserId)
  }
`;

export default REMOVE_LICENSE;
